import React from "react";
import "./Birthdays.css";
import { birthdays } from "./userData";

const ThisMonthBd = () => {
  const style = {
    width: "85%",
    height: "40px",
    backgroundColor: "#444444",
    borderRadius: "5px",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    wordBreak: "break-all",
    wordWrap: "break-word",
    padding: "0 10px",
    cursor: "pointer",
    transition: "background-color 0.1s ease-in-out",
  };

  function changeBackground(e) {
    e.target.style.background = "#6cf";
  }

  function defaultBackground(e) {
    e.target.style.background = "#444444";
  }
  //   const todayDate = new Date().getDate();
  const todayMonth = new Date().getMonth() + 1; // month start from 0 jan to 11 dec

  let value = birthdays.filter((date) => date.birthMonth === todayMonth);

  function sortBirthday(a, b) {
    return a.birthDate - b.birthDate;
  }
  value = value.sort(sortBirthday);
  if (value.length === 0) {
    var statusMsg = "No Birthdays To Display...!";
  } else {
    statusMsg = "";
  }
  return (
    <div className="list">
      <div>
        <h1 className="status">{statusMsg}</h1>
      </div>
      {value.map((person) => {
        return (
          <div key={person.name} className="nameList">
            <h4
              onMouseOver={changeBackground}
              onMouseLeave={defaultBackground}
              style={style}
              className="pName"
            >
              ~ {person.name}
            </h4>{" "}
            <h4 className="birthday">{person.birthDate}</h4>
          </div>
        );
      })}
    </div>
  );
};

export default ThisMonthBd;
